<template>
  <div class="issueItem" :class="{noneMarginRight : (issueItemIndex + 1) % 4 === 0}">

  </div>
</template>

<script>
    export default {
        name: "issue-item",
        props: ['issueItem' , 'issueItemIndex'],
    }
</script>

<style scoped lang="scss">
  @import "@/styles/Sunnyfactory.scss";
</style>



// WEBPACK FOOTER //
// src/components/menu/Sunnyfactory/IssueItem.vue